import { fetchApiJson } from './apiRequest.js';
const DEFAULT_ERROR =
  'Upcoming matches are temporarily unavailable.';

function normalizeGroup(
  value
) {
  const date =
    String(
      value?.date || ''
    ).trim();

  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(
      date
    )
  ) {
    return null;
  }

  const seen =
    new Set();

  const games =
    (
      Array.isArray(
        value?.games
      )
        ? value.games
        : []
    )
      .filter((game) => {
        const identity =
          String(
            game?.gameId ||
              game?.id ||
              [
                game?.away?.name,
                game?.home?.name,
                game?.timeLabel,
              ].join(':')
          )
            .trim()
            .toLowerCase();

        if (
          !identity ||
          seen.has(identity)
        ) {
          return false;
        }

        seen.add(identity);
        return true;
      })
      .map((game) => ({
        ...game,
        scheduleDate: date,
      }))
      .sort(
        (left, right) => {
          const leftEpoch =
            Number(
              left?.startTimeEpoch
            );

          const rightEpoch =
            Number(
              right?.startTimeEpoch
            );

          if (
            Number.isFinite(
              leftEpoch
            ) &&
            Number.isFinite(
              rightEpoch
            ) &&
            leftEpoch !==
              rightEpoch
          ) {
            return (
              leftEpoch -
              rightEpoch
            );
          }

          return String(
            left?.timeLabel ||
              ''
          ).localeCompare(
            String(
              right?.timeLabel ||
                ''
            ),
            undefined,
            {
              numeric: true,
              sensitivity:
                'base',
            }
          );
        }
      );

  return {
    date,
    games,
    error:
      String(
        value?.error || ''
      ).trim(),
  };
}

export async function getUpcomingScores({
  sport = 'women',
  startDate,
  signal,
} = {}) {
  const params =
    new URLSearchParams({
      sport: 'women',
    });

  if (
    /^\d{4}-\d{2}-\d{2}$/.test(
      String(
        startDate || ''
      )
    )
  ) {
    params.set(
      'startDate',
      startDate
    );
  }

  const { response, payload } =
    await fetchApiJson(
      `/api/upcoming?${params.toString()}`,
      {
        signal,
        headers: {
          Accept:
            'application/json',
        },
      }
    );

  if (!response.ok) {
    throw new Error(
      payload?.message ||
        DEFAULT_ERROR
    );
  }

  const groups =
    (
      Array.isArray(
        payload?.groups
      )
        ? payload.groups
        : []
    )
      .map(normalizeGroup)
      .filter(Boolean);

  return {
    startDate:
      String(
        payload?.startDate ||
          ''
      ).trim(),
    endDate:
      String(
        payload?.endDate ||
          ''
      ).trim(),
    groups,
    failedDates:
      Array.isArray(
        payload?.failedDates
      )
        ? payload.failedDates
            .map((value) =>
              String(
                value || ''
              ).trim()
            )
            .filter(Boolean)
        : [],
  };
}
